import React from 'react';
import { Box, Typography, LinearProgress, alpha } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { ACCENT, useAdminPageTheme } from '../../../pages/admin/adminUi';

const ProblemFormChecklist = ({ items, progress }) => {
  const { border, surface, muted, isDark } = useAdminPageTheme();
  const done = items.filter((i) => i.done).length;

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        border: `1px solid ${border}`,
        bgcolor: surface,
        position: { md: 'sticky' },
        top: { md: 88 },
      }}
    >
      <Typography sx={{ fontWeight: 800, fontSize: '0.85rem', mb: 0.5 }}>
        Ready to save
      </Typography>
      <Typography variant="caption" sx={{ color: muted, display: 'block', mb: 1.5 }}>
        {done} of {items.length} complete
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          mb: 2,
          height: 6,
          borderRadius: 99,
          bgcolor: alpha(ACCENT, isDark ? 0.15 : 0.08),
          '& .MuiLinearProgress-bar': { bgcolor: ACCENT, borderRadius: 99 },
        }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {items.map((item) => (
          <Box key={item.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            {item.done ? (
              <CheckCircleIcon sx={{ fontSize: 18, color: '#1a7f37', mt: 0.15 }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ fontSize: 18, color: muted, mt: 0.15 }} />
            )}
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: '0.78rem', lineHeight: 1.3 }}>
                {item.label}
              </Typography>
              {!item.done && item.hint && (
                <Typography variant="caption" sx={{ color: muted }}>
                  {item.hint}
                </Typography>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ProblemFormChecklist;
